export default __webpack_public_path__ + "57baebeb7196ab6c33a2a93dee41763c.svg";